"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = require("../model");
const permissions_1 = require("../permissions");
const brands_1 = require("./brands");
const roles_1 = __importDefault(require("./roles"));
const users = [
    {
        id: 'customerUser',
        type: model_1.UserType.CUSTOMER,
        email: 'user@customer.com',
        firstName: 'Customer',
        lastName: 'User',
        rolesMap: [
            {
                resource: `${permissions_1.RESOURCE_CUSTOMER_PREFIX}10001`,
                roles: ['CUSTOMER_USER'],
                permissions: (_a = roles_1.default.find((role) => role.id === 'CUSTOMER_USER')) === null || _a === void 0 ? void 0 : _a.permissions,
            },
        ],
    },
    {
        id: 'customerAdmin',
        type: model_1.UserType.CUSTOMER,
        email: 'admin@customer.com',
        firstName: 'Customer',
        lastName: 'Admin',
        rolesMap: [
            {
                resource: `${permissions_1.RESOURCE_CUSTOMER_PREFIX}10002`,
                roles: ['CUSTOMER_ADMIN'],
                permissions: (_b = roles_1.default.find((role) => role.id === 'CUSTOMER_ADMIN')) === null || _b === void 0 ? void 0 : _b.permissions,
            },
        ],
    },
    {
        id: 'teliaUser',
        type: model_1.UserType.TELIA,
        email: 'user@telia.com',
        firstName: 'User',
        lastName: 'Telia',
        rolesMap: [
            {
                resource: `${permissions_1.RESOURCE_BRAND_PREFIX}${brands_1.Brands.TELIA_NO}`,
                roles: ['TELIA_USER'],
                permissions: (_c = roles_1.default.find((role) => role.id === 'TELIA_USER')) === null || _c === void 0 ? void 0 : _c.permissions,
            },
            {
                resource: `${permissions_1.RESOURCE_BRAND_PREFIX}${brands_1.Brands.TELIA_SE}`,
                roles: ['TELIA_USER'],
                permissions: (_d = roles_1.default.find((role) => role.id === 'TELIA_USER')) === null || _d === void 0 ? void 0 : _d.permissions,
            },
        ],
    },
    {
        id: 'teliaAdmin',
        type: model_1.UserType.TELIA,
        email: 'admin@telia.com',
        firstName: 'Admin',
        lastName: 'Telia',
        rolesMap: [
            {
                resource: `${permissions_1.RESOURCE_BRAND_PREFIX}${permissions_1.RESOURCE_WILDCARD}`,
                roles: ['TELIA_USER'],
                permissions: (_e = roles_1.default.find((role) => role.id === 'TELIA_USER')) === null || _e === void 0 ? void 0 : _e.permissions,
            },
            {
                resource: `${permissions_1.RESOURCE_BRAND_PREFIX}${brands_1.Brands.TELIA_NO}`,
                roles: ['TELIA_ADMIN'],
                permissions: (_f = roles_1.default.find((role) => role.id === 'TELIA_ADMIN')) === null || _f === void 0 ? void 0 : _f.permissions,
            },
        ],
    },
    {
        id: 'allBrandAdmin',
        type: model_1.UserType.TELIA,
        email: 'admin@telia.com',
        firstName: 'Admin',
        lastName: 'Telia',
        rolesMap: [
            {
                resource: `${permissions_1.RESOURCE_BRAND_PREFIX}${permissions_1.RESOURCE_WILDCARD}`,
                roles: ['TELIA_ADMIN'],
                permissions: (_g = roles_1.default.find((role) => role.id === 'TELIA_ADMIN')) === null || _g === void 0 ? void 0 : _g.permissions,
            },
            {
                resource: `${permissions_1.RESOURCE_BRAND_PREFIX}${brands_1.Brands.TELIA_NO}`,
                roles: ['TELIA_ADMIN'],
                permissions: (_h = roles_1.default.find((role) => role.id === 'TELIA_USER')) === null || _h === void 0 ? void 0 : _h.permissions,
            },
        ],
    },
    {
        id: 'allBrandAdjuster',
        type: model_1.UserType.TELIA,
        email: 'adjuster@telia.com',
        firstName: 'Adjuster',
        lastName: 'Telia',
        rolesMap: [
            {
                resource: `${permissions_1.RESOURCE_BRAND_PREFIX}${permissions_1.RESOURCE_WILDCARD}`,
                roles: ['TELIA_ADJUSTER'],
                permissions: (_j = roles_1.default.find((role) => role.id === 'TELIA_ADJUSTER')) === null || _j === void 0 ? void 0 : _j.permissions,
            },
        ],
    },
    {
        id: 'allBrandApprover',
        type: model_1.UserType.TELIA,
        email: 'approver@telia.com',
        firstName: 'Approver',
        lastName: 'Telia',
        rolesMap: [
            {
                resource: `${permissions_1.RESOURCE_BRAND_PREFIX}${permissions_1.RESOURCE_WILDCARD}`,
                roles: ['TELIA_APPROVER'],
                permissions: (_k = roles_1.default.find((role) => role.id === 'TELIA_APPROVER')) === null || _k === void 0 ? void 0 : _k.permissions,
            },
        ],
    },
];
exports.default = users;
